import styled from 'styled-components';
import { TextField, Button } from '@mui/material';

export const Container = styled.div`
  padding: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  max-width: 600px;
  margin-top: 16px;
`;

export const SummaryTextField = styled(TextField)`
  .MuiInputBase-input {
    padding: 8px 12px;
  }
`;

export const GenerateButton = styled(Button)`
  && {
    background-color: #ff8800;
    border-radius: 20px;
    color: #fff;
    text-transform: none;
    white-space: nowrap;

    &:hover {
      background-color: #e67a00;
    }
  }
`;
